import instance from "src/API/MainAPI";

export function LabsWalletRequestRechargeAPI(data: { amount: number, depositorName: string }) {
  return instance.post('/v1/labs/wallets/recharges', data);
};

export function LabsWalletCancelRechargeAPI(rechargeId: number) {
  return instance.delete(`/v1/labs/wallets/recharges/${rechargeId}`);
};


// 충전 완료 확인 (폴링)
export function LabsWalletCheckRechargeCompleteAPI(rechargeId: number) {
  return instance.post(`/v1/labs/wallets/recharges/${rechargeId}`);
};


export function LabsWalletRechargeDetailsAPI(rechargeId: number) {
  return instance.get(`/v1/labs/wallets/recharges/${rechargeId}`);
};

export function LabsWalletCompanyDetailsAPI() {
  return instance.get('/v1/labs/wallets/company');
};

export function LabsWalletCompanyDetailsUpdateAPI(rechargeId: number, data: {
  companyName: string;
  companyRegistrationNumber: string;
}) {
  return instance.post('/v1/labs/wallets/recharges/${rechargeId}/tax-invoice', data);
};

export function LabsWalletTaxInvoiceAPI (
  rechargeId: number,
  bankbookImage: File,
  businessLicense: File,
  data: {
    companyName: string;
    email: string;
    phone: string;
  }
) {
  const formData = new FormData();
  formData.append('bankbookImage', bankbookImage);
  formData.append('businessLicense', businessLicense);
  formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));

  return instance.post(`/v1/labs/wallets/recharges/${rechargeId}/tax-invoice`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}; 
